export * from "components/RDW/components/RDWDetails";
